import React, { useState } from "react";
import {
Box,
Card,
Typography,
TextField,
Button,
Stack,
Checkbox,
FormControlLabel,
Snackbar,
Alert,
CircularProgress,
InputAdornment,
IconButton
} from "@mui/material";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";

import { useNavigate } from "react-router-dom";
import { Colors } from "../utils/colors";
import { adminFetch } from "../services/adminFetch"
import { adminPageSx } from "../utils/adminResponsive";

export default function CreateUser(){

const navigate = useNavigate();



const [formData,setFormData] = useState({
first_name:"",
last_name:"",
email:"",
phone:"",
password:"",
bank_name:"",
account_name:"",
account_number:""
});

const [notify,setNotify] = useState(true);
const [loading,setLoading] = useState(false);
const [showPassword,setShowPassword] = useState(false);



const [snackbar,setSnackbar] = useState({
open:false,
message:"",
severity:"success"
});

const showSnackbar = (message,severity="success")=>{
setSnackbar({open:true,message,severity});
};

const handleCloseSnackbar = ()=>{
setSnackbar({...snackbar,open:false});
};




const update = (field,value)=>{
setFormData(prev=>({...prev,[field]:value}));
};




const handleCreateUser = async () => {

if(
!formData.email ||
!formData.phone ||
!formData.password ||
!formData.first_name ||
!formData.last_name
){
showSnackbar("Please fill all required fields","error");
return;
}

setLoading(true);

try{
const data = await adminFetch("/api/user/create-user",
    {
        method:"POST",
        body:JSON.stringify({
        ...formData,
        notify
       })
    }
)

if(!data.status){
showSnackbar(data.message || "Failed to create user","error");
setLoading(false);
return;
}

showSnackbar(data.message || "User created successfully","success");



setFormData({
first_name:"",
last_name:"",
email:"",
phone:"",
password:"",
bank_name:"",
account_name:"",
account_number:""
});

setTimeout(()=>{
navigate("/admin/users");
},2000);

}catch(err){
console.log(err);
showSnackbar("Server error. Try again.","error");
}

setLoading(false);
};


return(

<Box sx={{
...adminPageSx
}}>

<Card sx={{p:{ xs:2, sm:4 }, maxWidth:700, mx:"auto"}}>

<Typography
variant="h5"
sx={{mb:3, color:Colors.accent, fontWeight:700}}
>
Create New User
</Typography>

<Stack spacing={2}>



<TextField
label="First Name"
fullWidth
value={formData.first_name}
onChange={(e)=>update("first_name",e.target.value)}
/>

<TextField
label="Last Name"
fullWidth
value={formData.last_name}
onChange={(e)=>update("last_name",e.target.value)}
/>




<TextField
label="Email"
fullWidth
value={formData.email}
onChange={(e)=>update("email",e.target.value)}
/>

<TextField
label="Phone"
fullWidth
value={formData.phone}
onChange={(e)=>update("phone",e.target.value)}
/>




<TextField
label="Password"
type={showPassword ? "text" : "password"}
fullWidth
value={formData.password}
onChange={(e)=>update("password",e.target.value)}
InputProps={{
endAdornment: (
<InputAdornment position="end">
<IconButton onClick={()=>setShowPassword((prev)=>!prev)} edge="end">
{showPassword ? <VisibilityOffIcon /> : <RemoveRedEyeIcon />}
</IconButton>
</InputAdornment>
)
}}
/>




<TextField
label="Bank Name"
fullWidth
value={formData.bank_name}
onChange={(e)=>update("bank_name",e.target.value)}
/>

<TextField
label="Account Name"
fullWidth
value={formData.account_name}
onChange={(e)=>update("account_name",e.target.value)}
/>

<TextField
label="Account Number"
fullWidth
value={formData.account_number}
onChange={(e)=>update("account_number",e.target.value)}
/>

</Stack>




<FormControlLabel
sx={{mt:2}}
control={
<Checkbox
checked={notify}
onChange={(e)=>setNotify(e.target.checked)}
/>
}
label="Notify user via email"
/>




<Button
fullWidth
variant="contained"
sx={{
mt:3,
backgroundColor:Colors.accent,
color:"#003300",
fontWeight:700
}}
onClick={handleCreateUser}
disabled={loading}
>
{loading ? (
<CircularProgress size={22} sx={{color:"#fff"}}/>
) : (
"Create User"
)}
</Button>

</Card>




<Snackbar
open={snackbar.open}
autoHideDuration={4000}
onClose={handleCloseSnackbar}
anchorOrigin={{vertical:"top",horizontal:"center"}}
>
<Alert severity={snackbar.severity} onClose={handleCloseSnackbar}>
{snackbar.message}
</Alert>
</Snackbar>

</Box>

);

}
